/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamTypeListValueEditorViewModel } from "../types/ExamTypeListValueEditorViewModel.ts";

export const examTypeListValueEditorViewModelSchema = z.object({
  id: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID da alternativa. `0` para criar uma nova alternativa; valor maior que `0` para editar uma existente.",
      ),
  ),
  value: z
    .string()
    .describe(
      "Texto da alternativa exibido ao aluno (pode conter HTML). Opcional.",
    )
    .nullish(),
  correctAnswer: z.optional(
    z
      .boolean()
      .describe("Define se esta alternativa é a resposta correta da questão."),
  ),
}) as unknown as ToZod<ExamTypeListValueEditorViewModel>;
